<div class="body">
  <div
    class="md:tw-w-full tw-mt-2 rtl:tw-ml-[-59px] ltr:tw-mr-[-59px]"
  >
    <div class="alert alert-warning border tw-text-center">
      <p class="tw-font-medium">
        {{ "messages.useTag" | translate }}
      </p>
    </div>
  </div>

  <ng-container *ngIf="!isCanSendVoice">
    <!-- counter -->
    <div class="md:tw-w-full tw-mt-1">
      <div class="row">
        <div class="2xl:tw-w-1/2 tw-w-full">
          <list-group-item
            [label]="'common.characterCount' | translate"
            [value]="smsLength"
          >
          </list-group-item>
        </div>

        <!-- partCount -->
        <div class="2xl:tw-w-1/2 tw-w-full">
          <list-group-item
            [label]="'common.partCount' | translate"
            [isShowValue]="false"
            [value]=""
          >
            <span
              content
              class="badge badge-light border tw-text-gray-800 tw-text-[13px] tw-whitespace-nowrap tw-overflow-x-auto tw-mr-2 tw-max-w-[80%] list-group-item-value"
              [ngClass]="
                appStateService.currentAppLang() == 'fa'
                  ? 'dir-ltr'
                  : 'dir-rtl'
              "
              [class.sms-part-scale-anim]="isChangeSmsCount"
            >
              <ng-container *ngIf="smsCount">
                <span
                  class="sms-part-count"
                  [class.text-danger.tw-text-base]="
                    isChangeSmsCount
                  "
                >
                  {{ smsCount }}
                </span>
                <small class="tw-opacity-70">/</small>
                <small class="tw-opacity-80">
                  {{ remainingCharUntilNextPart }}
                </small>
              </ng-container>
              <ng-container *ngIf="!smsCount"> - </ng-container>
            </span>
          </list-group-item>
        </div>
      </div>
    </div>

    <!-- sms body -->
    <div class="md:tw-w-full tw-mt-1">
      <div class="tw-flex">
        <mat-form-field appearance="outline" class="tw-w-full">
          <mat-label>
            {{ "common.smsBody" | translate }}
          </mat-label>
          <!-- TODO textarea torbatian -->
          <div class="text-editor">
            <textarea
              #smsbody
              [maxlength]="maxSmsBodyCount"
              class="sms-body tw-text-right font-vazir-ui"
              [formControlName]="input_smsBodyControlName"
              [(ngModel)]="smsBody"
              matInput
              [rows]="input_smsBodyRow"
              (input)="convertSmsBodyNumbers()"
              (input)="getSmsCount()"
              (input)="emitSmsBody()"
              spellcheck="false"
              autocomplete="off"
              [readonly]="isReadOnlySmsBody"
            >
            </textarea>

            <!-- <div #backdrop class="text-editor-backdrop">
            <div [class.text-editor-highlights]="smsBody?.length"
            [innerHTML]="smsBody|seperateSmsBodyByPart: this.sendNumberSelected?.udhLen">
            </div>
          </div> -->

            <div
              *ngIf="input_isShowEditorOptions"
              class="text-editor__buttons tw-border-r tw-pr-3 tw-border-dashed tw-border-r-slate-300 dark:tw-border-r-slate-700 tw-h-[100%]"
            >
              <!-- sms preview  -->
              <a
                *ngIf="input_isShowSmsPreview"
                class="tw-my-[4px]"
                [ngClass]="
                  (privateNumber || senderNumberId) && finalSmsBody
                    ? 'tw-cursor-pointer'
                    : 'tw-cursor-not-allowed tw-opacity-50'
                "
                [matTooltip]="'common.smsPreview' | translate"
                matTooltipPosition="left"
                (click)="
                  !input_disabled &&
                  (privateNumber || senderNumberId) &&
                  finalSmsBody
                    ? onShowSmsPreview()
                    : ''
                "
              >
                <span
                  [inlineSVG]="
                    '/assets/media/svg/icons/eye-svgrepo-com.svg'
                  "
                ></span>
              </a>

              <!-- sms template  -->
              <a
                *ngIf="input_isShowSmsTemplate"
                class="tw-my-[4px] tw-cursor-pointer"
                [matTooltip]="'common.smsTemplateList' | translate"
                matTooltipPosition="left"
                (click)="!input_disabled ? onShowSmsTemplate() : ''"
              >
                <span
                  [inlineSVG]="
                    '/assets/media/svg/icons/sms-template.svg'
                  "
                ></span>
              </a>

              <!-- short link -->
              <ng-container *ngIf="input_showShortLink">
                <a
                  class="tw-my-[4px] tw-cursor-pointer"
                  (click)="
                    !input_disabled ? onShowShortLinks() : ''
                  "
                  [matTooltip]="'common.shortLinkList' | translate"
                  matTooltipPosition="left"
                >
                  <span
                    [inlineSVG]="
                      '/assets/media/svg/icons/short-link.svg'
                    "
                  ></span>
                </a>
              </ng-container>

              <!-- emoji -->
              <ng-container *ngIf="input_showEmojiPicker">
                <emoji-picker
                  class="tw-my-[4px]"
                  (emoji)="addEmojiToMessage($event)"
                >
                </emoji-picker>
              </ng-container>

              <!-- text header -->
              <ng-container *ngIf="input_isAddHeader">
                <a
                  class="tw-my-[4px] tw-cursor-pointer"
                  [matTooltip]="'common.header' | translate"
                  matTooltipPosition="left"
                  (click)="onShowHeader()"
                >
                  <span
                    [inlineSVG]="'/assets/media/svg/icons/text.svg'"
                  ></span>
                </a>
                <ng-template #disableHeader>
                  <a class="disable-icon tw-my-[4px]">
                    <span
                      [inlineSVG]="
                        '/assets/media/svg/icons/text.svg'
                      "
                    ></span>
                  </a>
                </ng-template>
              </ng-container>

              <!-- signature -->
              <ng-container *ngIf="input_isAddSignature">
                <a
                  class="tw-my-[4px] tw-cursor-pointer"
                  [matTooltip]="'common.signature' | translate"
                  matTooltipPosition="left"
                  (click)="onShowSignature()"
                >
                  <span
                    [inlineSVG]="
                      '/assets/media/svg/icons/signature.svg'
                    "
                  ></span>
                </a>
                <ng-template #disableSignature>
                  <a class="disable-icon tw-my-[4px]">
                    <span
                      class="disable-icon"
                      [inlineSVG]="
                        '/assets/media/svg/icons/signature.svg'
                      "
                    ></span>
                  </a>
                </ng-template>
              </ng-container>

              <!-- eraser text -->
              <a
                class="tw-mt-[4px] tw-cursor-pointer"
                [matTooltip]="'common.clear' | translate"
                matTooltipPosition="left"
                *ngIf="smsBody; else disableEraser"
                (click)="!input_disabled ? clearSmsBody() : ''"
              >
                <span
                  [inlineSVG]="'/assets/media/svg/icons/eraser.svg'"
                ></span>
              </a>
              <ng-template #disableEraser>
                <a class="disable-icon tw-mt-[4px]">
                  <span
                    [inlineSVG]="
                      '/assets/media/svg/icons/eraser.svg'
                    "
                  ></span>
                </a>
              </ng-template>
            </div>
          </div>
        </mat-form-field>
      </div>
    </div>

    <!-- covert to persian number -->
    <div class="md:tw-w-full tw-mt-2 tw-mb-5">
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="checkbox-section">
          <mat-slide-toggle (click)="convertNumbersToggle()">
            {{ "common.convertToPersianNumbers" | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isCanSendVoice">
    <!-- groupId -->
    <voice-message-groups-select-search
      class="tw-w-full"
      label="common.voiceGroup"
      [value]="voiceMessageGroupId"
      (valueChange)="voiceMessageGroupId = $event"
    >
    </voice-message-groups-select-search>

    <!-- voice message -->
    <app-voice-message-select-search
      type="voiceMessagesByGroupId"
      [id]="voiceMessageGroupId"
      [label]="input_voiceMessageLabel | translate"
      [control]="input_form?.get(input_voiceMessageControlName)"
      [value]="voiceMessageDetails?.voiceMessageId"
      (itemChange)="getVoiceMessages($event)"
    >
    </app-voice-message-select-search>

    <div>
      <div class="row">
        <!-- maxTryCount -->
        <div class="tw-w-full">
          <form-field
            class="tw-w-full"
            label="common.maxTryCount"
            [control]="
              input_form?.get(input_maxTryCountControlName)
            "
            [value]="voiceMessageDetails.maxTryCount ?? 2"
            (valueChange)="voiceMessageDetails.maxTryCount = $event"
            (change)="emitVoiceMessages()"
          >
          </form-field>
        </div>

        <!-- minuteBetweenTries -->
        <div class="tw-w-full">
          <mat-form-field class="tw-w-full" appearance="outline">
            <mat-label>{{
              "common.minuteBetweenTries" | translate
            }}</mat-label>
            <input
              type="text"
              placeholder="Pick one"
              aria-label="Number"
              matInput
              [formControlName]="
                input_minuteBetweenTriesControlName
              "
              [matAutocomplete]="auto"
              [ngModel]="
                voiceMessageDetails.minuteBetweenTries ?? 10
              "
              min="1"
              (ngModelChange)="
                emitVoiceMessages();
                voiceMessageDetails.minuteBetweenTries = $event
              "
            />
            <mat-autocomplete
              autoActiveFirstOption
              #auto="matAutocomplete"
            >
              <mat-option [value]="10">
                10 {{ "common.minute" | translate }}
              </mat-option>

              <mat-option [value]="20">
                20 {{ "common.minute" | translate }}
              </mat-option>

              <mat-option [value]="30">
                30 {{ "common.minute" | translate }}
              </mat-option>

              <mat-option [value]="60">
                1 {{ "common.hour" | translate }}
              </mat-option>

              <mat-option [value]="120">
                2 {{ "common.hour" | translate }}
              </mat-option>

              <mat-option [value]="300">
                5 {{ "common.hour" | translate }}
              </mat-option>

              <mat-option [value]="1440">
                1 {{ "common.day" | translate }}
              </mat-option>

              <mat-option [value]="2880">
                2 {{ "common.day" | translate }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isCanSendSocialMedia">
    <!--social media fileId -->
    <app-social-media-message-select-search
      [label]="input_socialMediaMessageLabel | translate"
      [control]="
        input_form?.get(input_socialMediaMessageControlName)
      "
      [value]="socialMediaMessageDetails?.socialMediaFileId"
      (itemChange)="getSocialMediaMessages($event)"
    >
    </app-social-media-message-select-search>

    <div>
      <div class="row">
        <!--social Media ApplicationId -->
        <app-social-media-applications-select-search
          [label]="input_socialMediaApplicationLabel | translate"
          [control]="
            input_form?.get(input_socialMediaApplicationControlName)
          "
          [value]="
            socialMediaMessageDetails?.socialMediaApplicationId
          "
          (itemChange)="getSocialMediaApplications($event)"
        >
        </app-social-media-applications-select-search>
      </div>
    </div>
  </ng-container>
</div>
